import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoPolygonTag } from '../../../../../state/tags/definitions/geo';
import { TagNew } from '../../../TagNew';

import { tagThemeSmall } from '../../../tag_theme';

export interface IGeoPolygonTagItemProps {
  tag: IGeoPolygonTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoPolygonTagItem = (props: IGeoPolygonTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
